import { motion, AnimatePresence } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';

interface ColorScheme {
  text: string;
  background: string;
  border: string;
}

interface BaseToastProps {
  message: string | null;
  colorScheme: ColorScheme;
}

interface BaseToastInnerContainerProps {
  colorScheme: ColorScheme;
}

const BaseToastOuterContainer = styled.div`
  z-index: 3;

  position: fixed;
  bottom: 0;
  left: 0;

  width: 100vw;

  padding: 20px;

  @media only screen and (min-width: 768px) {
    display: flex;
    justify-content: flex-end;
  }
`;

const BaseToastInnerContainer = styled.div<BaseToastInnerContainerProps>`
  width: 100%;

  background-color: ${(props) => props.colorScheme.background};
  border: 1.5px solid ${(props) => props.colorScheme.border};

  padding: 20px 60px;
  border-radius: 16px 0px;

  span {
    color: ${(props) => props.colorScheme.text};
    font-size: 20px;
    font-family: 'CircularStd-Bold';
  }

  box-shadow: rgb(204, 219, 232) 3px 3px 6px 0px,
    rgba(255, 255, 255, 0.5) -3px -3px 6px 1px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const BaseToast: React.FC<BaseToastProps> = ({ message, colorScheme }) => {
  return (
    <BaseToastOuterContainer>
      <AnimatePresence>
        {message ? (
          <motion.div
            key={`${message.toLowerCase().split(' ').join('-')}-toast`}
            initial={{ opacity: 0, y: '100vh' }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: '100vh' }}
            transition={{ duration: 0.5 }}
          >
            <BaseToastInnerContainer colorScheme={colorScheme}>
              <span>{message}</span>
            </BaseToastInnerContainer>
          </motion.div>
        ) : null}
      </AnimatePresence>
    </BaseToastOuterContainer>
  );
};

export default BaseToast;
